
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'4-3'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            여행 관리 - 여행일정 {{ $route.query.schedule_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.schedule_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_type_division'>여행타입구분<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_type_division"
                v-model="statusData.travelTypeDivision"
              >
                <option value='1'>국악와인열차</option>
                <option value='2'>팔도장터열차</option>
                <option value='3'>일반기차여행</option>
                <option value='4'>버스/자유여행</option>
                <option value='5'>섬/제주/해외여행</option>
              </select>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_ID_use_schedule'>여행상품명<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_product_ID_use_schedule"
                v-model="formData.travelProductID"
              >
                <option
                  v-for="item in statusData.travelProductIDArray"
                  :key="item.travel_product_ID"
                  :value="item.travel_product_ID"
                >
                  {{ item.travel_product_name }}
                </option>
              </select>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='schedule_start_day'>출발일<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText Admin_PageDetail_inputDate"
                type='date'
                id = 'schedule_start_day'
                v-model="formData.scheduleStartDay"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.scheduleStartDayError}}</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='schedule_end_day'>종료일<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText Admin_PageDetail_inputDate"
                type='date'
                id = 'schedule_end_day'
                v-model="formData.scheduleEndDay"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.scheduleEndDayError}}</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='schedule_boarding'>탑승지 작성</label>
              <div class="Admin_TagInput_TagWrap">
                <p>
                  - 탑승지 작성 후 엔터로 추가되며, X 클릭 또는 키보드 DEL키로 삭제<br>
                  - 글자수 최대 10자, 탑승지 최대 10개 가능
                </p>
                <div class="Admin_TagInput_TagBox">
                  <p class="Admin_TagInput_Tag" v-for="(boarding, index) in statusData.boardings" :key="index">
                    {{ boarding }}
                    <span class="delete-tag" @click="removeBoarding(index)"></span>
                  </p>
                  <input
                    type="text"
                    id="schedule_boarding"
                    maxLength="10"
                    placeholder="탑승지를 입력해주세요"
                    v-model="statusData.boardingInput"
                    @keyup.enter="addBoarding"
                    @keydown.backspace="removeLastBoarding"
                    />
                </div>
              </div>
            </div>
            <p class="Admin_ErrorBox">{{ errorData.scheduleBoardingError }}</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='schedule_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="schedule_status"
                v-model="formData.scheduleStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='schedule_option_use_status'>옵션 사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="schedule_option_use_status"
                v-model="formData.scheduleOptionUseStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
            <div class="Admin_PageDetail_addInfo">
              * 옵션 사용 : 개별 옵션(개별 옵션과 리스트) / 그룹 옵션(연동되는 옵션과 리스트)을 선택하여 작성<br/>
              * 옵션 미사용 : 별도 옵션 없이 아래 "여행 기본 정보"에서 가격, 좌석수 작성
            </div>
          </div>

          <div v-if="formData.scheduleOptionUseStatus === '2'" class="Admin_PageDetail_groupWrap">
            <div class="Admin_PageDetail_groupWrapTit">
              여행 기본 정보
              <span>옵션 미사용 시 기본 가격, 좌석수를 입력해야합니다.</span>
            </div>
            <div class="Admin_PageDetail_groupBox_Div borderLeftNone">
              <label for='schedule_price'>가격(대인)<span class="pointTextRed"> * </span></label>
              <input
                type='text'
                id = 'schedule_price'
                placeholder = "가격(대인)을 입력해 주세요."
                maxLength="12"
                v-model="formData.schedulePrice"
                @input="number_change_general('schedulePrice')"
              />
              <p class="Admin_PageDetail_groupBox_ErrorBox">{{errorData.schedulePriceError}}</p>
            </div>
            <div class="Admin_PageDetail_groupBox_Div borderLeftNone">
              <label for='schedule_price_child'>가격(소인)</label>
              <input
                type='text'
                id = 'schedule_price_child'
                placeholder = "가격(소인)을 입력해 주세요."
                maxLength="12"
                v-model="formData.schedulePriceChild"
                @input="number_change_general('schedulePriceChild')"
              />
              <p class="Admin_PageDetail_groupBox_ErrorBox">{{errorData.schedulePriceChildError}}</p>
            </div>
            <div class="Admin_PageDetail_groupBox_Div borderLeftNone">
              <label for='schedule_seats'>총 좌석수<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'schedule_seats'
                placeholder = "총 좌석수를 입력해 주세요."
                maxLength="3"
                v-model="formData.scheduleSeats"
                @input="number_change_general('scheduleSeats')"
              />
              <p class="Admin_PageDetail_groupBox_ErrorBox">{{errorData.scheduleSeatsError}}</p>
            </div>
          </div>
          <div v-if="formData.scheduleOptionUseStatus === '1'">
            <div class="Admin_PageDetail_BoxWrap">
              <div class="Admin_PageDetail_BoxDiv">
                <label for='schedule_group_option_status'>옵션 종류 선택<span class="pointTextRed"> * </span></label>
                <select
                  class="Admin_PageDetail_inputSelect"
                  id="schedule_group_option_status"
                  v-model="formData.scheduleGroupOptionStatus"
                >
                  <option value='0'>개별 옵션 (1개 옵션에 개별 리스트 및 옵션 설정)</option>
                  <option value='1'>그룹 옵션 (그룹 옵션에 서로 연동되는 리스트 및 옵션 설정)</option>
                </select>
              </div>
            </div>

            <div class="Admin_PageDetail_groupWrap">
              <!-- 그룹 옵션 사용 시 그룹옵션에 대한 내용 나타남 -->
              <div class="mgb40" v-if="formData.scheduleGroupOptionStatus === '1'">
                <div class="Admin_PageDetail_groupWrapTit">
                  그룹 옵션 설정
                  <span>아래 "그룹 옵션명" 작성 및 해당 그룹의 리스트와 옵션을 추가할 수 있습니다.</span>
                </div>
                <div class="Admin_PageDetail_groupBox_gm">
                  <div>
                    <label for='schedule_group_option_title'>그룹 옵션명<span class="pointTextRed"> * </span></label>
                    <input
                      type='text'
                      id='schedule_group_option_title'
                      maxLength="10"
                      placeholder="10자 내의 그룹 옵션명을 입력해 주세요."
                      v-model="formData.scheduleGroupOptionTitle"
                    />
                  </div>
                  <p class="Admin_PageDetail_groupBox_ErrorBox">{{ errorData.scheduleGroupOptionTitleError }}</p>
                </div>

                <div>
                  <div class="Admin_PageDetail_groupBtn" v-if="formData.scheduleGroupOptionStatus === '1'">
                    <p v-on:click="add_schedule_group_option">
                      리스트 추가
                    </p>
                  </div>

                  <div class="Admin_PageDetail_groupInfoBox">
                    <p>1. "리스트 추가" 버튼을 클릭하여 리스트를 추가할 수 있습니다.</p>
                    <p>2. 아래 그룹 리스트의 리스트 클릭&amp;드래그하여 순서를 변경할 수 있으며, 보이는 순서대로 홈페이지에 노출됩니다.</p>
                    <p>3. 아래 그룹 리스트의 리스트 클릭하여 상단에서 리스트명을 변경하거나, 하단에서 리스트의 상세 옵션을 설정할 수 있습니다.</p>
                    <p>4. 복사, 삭제 아이콘을 클릭하여 복사, 삭제할 수 있습니다.</p>
                  </div>

                  <div class="Admin_PageDetail_groupBox_gs displayFlex" v-if="formData.scheduleGroupOptionArray.length > 0">
                    <div class="Admin_PageDetail_groupBox_gsTit">
                      그룹 리스트
                    </div>
                    <div>
                      <div v-if="statusData.selectedTab !== null" class="Admin_PageDetail_groupBox_gs01">
                        <label for="scheduleGroupOptionName">리스트명</label>
                        <input
                          type="text"
                          id="scheduleGroupOptionName"
                          maxLength="10"
                          v-model="formData.scheduleGroupOptionArray[statusData.selectedTab].schedule_group_option_name"
                          placeholder="10자 내의 리스트명을 작성해 주세요."
                        />
                      </div>

                      <draggable v-model="formData.scheduleGroupOptionArray" @end="updateOrder">
                        <div
                          v-for="(option, index) in formData.scheduleGroupOptionArray"
                          :key="option.index"
                          v-if="option.schedule_group_option_delete_status !== 1"
                          class="Admin_PageDetail_groupBox_gsTab"
                          :class="{ selected: statusData.selectedTab === index }">
                          <div @click="selectTab(index)">
                            <div>
                              <img src="../../../assets/images/icon/icon_menuOpen.png" alt="드래그 아이콘" />
                              <p>{{ option.schedule_group_option_name || '리스트명을 변경해주세요' }}</p>
                            </div>
                            <div class="Admin_PageDetail_groupBox_gsTabBtn">
                              <button class='copy-tab' @click="copyGroupOption(index)">복사</button>
                              <button class='deleted-tab' @click="markAsDeleted(index)">삭제</button>
                            </div>
                          </div>
                        </div>
                      </draggable>
                  </div>
                  </div>
                </div>
              </div>

              <!-- 개별 옵션 -->
              <div>
                <div class="Admin_PageDetail_groupWrapTit">
                  {{ optionSettingTitle }}
                  <span>{{ optionButtonText }}</span>
                </div>

                <div class="Admin_PageDetail_groupBtn">
                  <p v-on:click="add_schedule_option">옵션 추가</p>
                </div>

                <div
                  class="Admin_PageDetail_groupBox"
                  v-for="(item, index) in filteredScheduleOptionArray"
                  v-if="item.schedule_option_delete_status === 0"
                  :key="index"
                >
                  <div class="Admin_PageDetail_groupBox_Main">
                    <div class="Admin_PageDetail_groupBtn02">
                      <p v-on:click="delete_schedule_option(index)">
                        옵션 삭제
                      </p>
                    </div>
                    <div>
                      <div class="Admin_PageDetail_groupBox_Div">
                        <label :for="'schedule_option_order' + index">순서<span class="pointTextRed"> * </span></label>
                        <input
                          type='text'
                          :id="'schedule_option_order' + index"
                          maxLength="4"
                          placeholder="순서를 입력해주세요."
                          v-model="item.schedule_option_order"
                          @input="number_change(index, 'schedule_option_order')"
                        />
                        <p class="Admin_PageDetail_groupBox_ErrorBox">{{ item.schedule_option_order_error }}</p>
                      </div>
                      <div class="Admin_PageDetail_groupBox_Div">
                        <label :for="'schedule_option_name' + index">옵션명<span class="pointTextRed"> * </span></label>
                        <input
                          type='text'
                          :id="'schedule_option_name' + index"
                          maxLength="10"
                          placeholder="10자 내의 옵션명을 입력해주세요."
                          v-model="item.schedule_option_name"
                        />
                        <p class="Admin_PageDetail_groupBox_ErrorBox">{{ item.schedule_option_name_error }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="Admin_PageDetail_groupBox_Sub">
                    <div class="Admin_PageDetail_groupBtn03">
                      <p v-on:click="add_schedule_option_list(index)">
                        리스트 추가
                      </p>
                    </div>

                    <div
                      class="Admin_PageDetail_groupBox_SubInfo"
                      v-for="(option_list_item, listIndex) in item.schedule_option_list"
                      v-if="option_list_item.schedule_option_list_delete_status === 0"
                      :key="listIndex"
                    >
                      <div :class="['Admin_PageDetail_groupBtn04', getRowColor(listIndex)]">
                        <p v-on:click="delete_schedule_option_list(index, listIndex)">
                          리스트 삭제
                        </p>
                      </div>

                      <div :class="[getRowColor(listIndex)]">
                        <div class="Admin_PageDetail_groupBox_Div">
                          <label :for="'schedule_option_list_order' + listIndex + index">순서<span class="pointTextRed"> * </span></label>
                          <input
                            type='text'
                            :id="'schedule_option_list_order' + listIndex + index"
                            maxLength="4"
                            placeholder="순서를 입력해주세요."
                            v-model="option_list_item.schedule_option_list_order"
                            @input="number_change(index, 'schedule_option_list_order', listIndex)"
                          />
                          <p class="Admin_PageDetail_groupBox_ErrorBox">{{ option_list_item.schedule_option_list_order_error }}</p>
                        </div>
                        <div class="Admin_PageDetail_groupBox_Div">
                          <label :for="'schedule_option_list_name' + listIndex">리스트명<span class="pointTextRed"> * </span></label>
                          <input
                            type='text'
                            :id="'schedule_option_list_name' + listIndex"
                            maxLength="10"
                            placeholder="10자 내 리스트를 입력해주세요."
                            v-model="option_list_item.schedule_option_list_name"
                          />
                          <p class="Admin_PageDetail_groupBox_ErrorBox">{{ option_list_item.schedule_option_list_name_error }}</p>
                        </div>
                        <div class="Admin_PageDetail_groupBox_Div">
                          <label :for="'schedule_option_list_price' + listIndex + index">가격(대인)<span class="pointTextRed"> * </span></label>
                          <input
                            type='text'
                            :id="'schedule_option_list_price' + listIndex + index"
                            maxLength="10"
                            placeholder="가격(대인)을 입력해주세요."
                            v-model="option_list_item.schedule_option_list_price"
                            @input="number_change(index, 'schedule_option_list_price', listIndex)"
                          />
                          <p class="Admin_PageDetail_groupBox_ErrorBox">{{ option_list_item.schedule_option_list_price_error }}</p>
                        </div>
                        <div class="Admin_PageDetail_groupBox_Div">
                          <label :for="'schedule_option_list_price_child' + listIndex + index">가격(소인)</label>
                          <input
                            type='text'
                            :id="'schedule_option_list_price_child' + listIndex + index"
                            maxLength="10"
                            placeholder="가격(소인)을 입력해주세요."
                            v-model="option_list_item.schedule_option_list_price_child"
                            @input="number_change(index, 'schedule_option_list_price_child', listIndex)"
                          />
                          <p class="Admin_PageDetail_groupBox_ErrorBox">{{ option_list_item.schedule_option_list_price_child_error }}</p>
                        </div>
                        <div class="Admin_PageDetail_groupBox_Div">
                          <label :for="'schedule_option_list_seats' + listIndex + index">총 좌석수<span class="pointTextRed"> * </span></label>
                          <input
                            type='text'
                            :id="'schedule_option_list_seats' + listIndex + index"
                            maxLength="10"
                            placeholder="총 좌석수를 입력해주세요."
                            v-model="option_list_item.schedule_option_list_seats"
                            @input="number_change(index, 'schedule_option_list_seats', listIndex)"
                          />
                          <p class="Admin_PageDetail_groupBox_ErrorBox">{{ option_list_item.schedule_option_list_seats_error }}</p>
                        </div>
                        <div class="Admin_PageDetail_groupBox_Div">
                          <label :for="'schedule_option_list_seats_max' + listIndex + index">최소예약인원<span class="pointTextRed"> * </span></label>
                          <input
                            type='text'
                            :id="'schedule_option_list_seats_max' + listIndex + index"
                            maxLength="10"
                            placeholder="에약가능 좌석수를 입력해주세요."
                            v-model="option_list_item.schedule_option_list_seats_max"
                            @input="number_change(index, 'schedule_option_list_seats_max', listIndex)"
                          />
                          <p class="Admin_PageDetail_groupBox_ErrorBox">{{ option_list_item.schedule_option_list_seats_max_error }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button class="Admin_PageHeader_btn01" v-on:click="check_form">
            {{ $route.query.schedule_ID === undefined ? '등록' : '수정' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import draggable from 'vuedraggable'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_travel_product_use_where,
  get_schedule_one,
  insert_schedule,
  update_schedule
} from '../../ETC/Axios.vue'
import {
  removeWhitespace
} from '../../ETC/Validation.vue'

export default {
  name: 'AdminTravelProductManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner,
    draggable
  },
  setup () {
    return {
      formData: ref({
        travelProductID: '',
        scheduleStartDay: '',
        scheduleEndDay: '',
        scheduleBoarding: '',
        schedulePrice: '0',
        schedulePriceChild: '0',
        scheduleSeats: '0',
        scheduleStatus: '1',
        scheduleOptionUseStatus: '2',
        scheduleGroupOptionStatus: '0',
        scheduleGroupOptionTitle: '',
        scheduleGroupOptionArray: [],
        scheduleOptionArray: []
      }),
      errorData: ref({
        scheduleStartDayError: '',
        scheduleEndDayError: '',
        scheduleBoardingError: '',
        schedulePriceError: '',
        schedulePriceChildError: '',
        scheduleSeatsError: '',
        scheduleGroupOptionTitleError: ''
      }),
      statusData: ref({
        spinnerStatus: false,
        travelProductIDArray: [],
        boardings: [],
        travelTypeDivision: '1',
        mountedFirst: false,
        scheduleOptionIndex: 0,
        scheduleGroupOptionIndex: 0,
        selectedTab: null
      })
    }
  },
  watch: {
    'statusData.travelTypeDivision': function (newValue) {
      this.fetchTravelTypeUse(newValue)
    },
    'formData.scheduleGroupOptionStatus': function (newValue) {
      this.formData.scheduleGroupOptionStatus = newValue
      if (this.$route.query.schedule_ID !== undefined) {
        get_schedule_one(this.$route.query.schedule_ID).then((result) => {
          const schedule = result.schedule_rows[0]
          this.statusData.travelTypeDivision = schedule.travel_type_division
          this.formData.travelProductID = schedule.travel_product_ID_use_schedule
          this.formData.scheduleStartDay = schedule.schedule_start_day
          this.formData.scheduleEndDay = schedule.schedule_end_day
          this.statusData.boardings = JSON.parse(schedule.schedule_boarding)
          this.formData.schedulePrice = String(schedule.schedule_price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.formData.schedulePriceChild = String(schedule.schedule_price_child).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.formData.scheduleSeats = String(schedule.schedule_seats).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.formData.scheduleGroupOptionTitle = schedule.schedule_group_option_title
          this.formData.scheduleStatus = String(schedule.schedule_status)

          if (newValue === '0') {
            this.formData.scheduleOptionArray = result.schedule_option_rows.filter(
              option => option.schedule_group_option_ID_use_schedule_option === 0
            ); this.statusData.scheduleOptionIndex = this.formData.scheduleOptionArray.length
            result.schedule_option_list_rows.forEach(option_list => {
              const option = this.formData.scheduleOptionArray.find(opt => opt.schedule_option_ID === option_list.schedule_option_ID_use_schedule_option_list)
              if (option) {
                if (!option.schedule_option_list) {
                  option.schedule_option_list = []
                }
                option.schedule_option_list.push(option_list)
              }
            })
          } else {
            this.formData.scheduleGroupOptionArray = result.schedule_group_option_rows
            this.statusData.scheduleGroupOptionIndex = this.formData.scheduleGroupOptionArray.length

            this.formData.scheduleGroupOptionArray.forEach(groupOption => {
              groupOption.schedule_option = result.schedule_option_rows.filter(opt => opt.schedule_group_option_ID_use_schedule_option === groupOption.schedule_group_option_ID)
              groupOption.schedule_option.forEach(option => {
                if (!option.schedule_option_list) {
                  option.schedule_option_list = []
                }
                option.schedule_option_list = result.schedule_option_list_rows.filter(optList => optList.schedule_option_ID_use_schedule_option_list === option.schedule_option_ID)
              })
            })
          }
        })
      }
    }
  },
  methods: {
    addBoarding () {
      const inputText = this.statusData.boardingInput.trim()
      if (!inputText) {
        return
      }
      if (this.statusData.boardings.includes(inputText)) {
        alert('이미 존재하는 태그입니다.')
      } else if (this.statusData.boardings.length >= 20) {
        alert('태그는 최대 10개까지만 추가할 수 있습니다.')
      } else {
        this.statusData.boardings.push(inputText)
        this.statusData.boardingInput = ''
      }
    },
    removeLastBoarding (event) {
      if (event.keyCode === 8 && this.statusData.boardings.length > 0) {
        this.statusData.boardings.pop()
        event.preventDefault()
      }
    },
    removeBoarding (index) {
      this.statusData.boardings.splice(index, 1)
    },
    fetchTravelTypeUse (newValue) {
      get_travel_product_use_where(newValue).then(response => {
        if (this.$route.query.schedule_ID !== undefined && this.statusData.mountedFirst) {
          this.formData.travelProductID = response[0].travel_product_ID
        }
        if (this.$route.query.schedule_ID === undefined) {
          this.formData.travelProductID = response[0].travel_product_ID
        }
        this.statusData.travelProductIDArray = response
        this.statusData.mountedFirst = true
      })
    },
    add_schedule_option: function () {
      let lastOrder = 0
      let optionArray

      if (this.formData.scheduleGroupOptionStatus === '0') {
        optionArray = this.formData.scheduleOptionArray
      } else if (this.formData.scheduleGroupOptionStatus === '1' && this.statusData.selectedTab !== null) {
        optionArray = this.formData.scheduleGroupOptionArray[this.statusData.selectedTab].schedule_option
      } else {
        alert('그룹 옵션에서 그룹 리스트를 선택해주세요.')
        return
      }

      if (optionArray.length > 0) {
        lastOrder = Math.max(...optionArray.map(option => option.schedule_option_order))
      }

      const newOption = {
        option_list_num: 0,
        schedule_option_ID: 0,
        schedule_ID_use_schedule_option: 0,
        schedule_option_name: '',
        schedule_option_name_error: '',
        schedule_option_order: lastOrder + 1,
        schedule_option_order_error: '',
        schedule_option_delete_status: 0,
        schedule_option_list: []
      }

      optionArray.push(newOption)
      this.$forceUpdate()

      this.$nextTick(() => {
        const elementId = `schedule_option_name${optionArray.length - 1}`
        const inputElement = document.getElementById(elementId)
        if (inputElement) {
          inputElement.focus()
        }
      })
    },
    delete_schedule_option: function (index) {
      let optionArray = this.formData.scheduleGroupOptionStatus === '0' ? this.formData.scheduleOptionArray : this.formData.scheduleGroupOptionArray[this.statusData.selectedTab].schedule_option
      if (index !== -1) {
        optionArray[index] = {
          ...optionArray[index],
          schedule_option_delete_status: 1
        }
        optionArray = [...optionArray]
      }
      this.$forceUpdate()
    },
    add_schedule_option_list: function (index) {
      let optionArray = this.formData.scheduleGroupOptionStatus === '0' ? this.formData.scheduleOptionArray : this.formData.scheduleGroupOptionArray[this.statusData.selectedTab].schedule_option
      const option = optionArray[index]
      if (!option) {
        alert('옵션이 없습니다.')
        return
      }
      let lastOrder = 0
      if (option.schedule_option_list.length > 0) {
        lastOrder = Math.max(...option.schedule_option_list.map(list => list.schedule_option_list_order))
      }
      const newListIndex = option.schedule_option_list.length
      const newOptionList = {
        schedule_option_list_ID: 0,
        schedule_option_ID_use_schedule_option_list: 0,
        schedule_option_list_name: '',
        schedule_option_list_name_error: '',
        schedule_option_list_price: 0,
        schedule_option_list_price_error: '',
        schedule_option_list_price_child: 0,
        schedule_option_list_price_child_error: '',
        schedule_option_list_seats: 0,
        schedule_option_list_seats_error: '',
        schedule_option_list_seats_max: 1,
        schedule_option_list_seats_max_error: '',
        schedule_option_list_order: lastOrder + 1,
        schedule_option_list_order_error: '',
        schedule_option_list_delete_status: 0
      }
      option.schedule_option_list.push(newOptionList)
      this.$forceUpdate()
      this.$nextTick(() => {
        const element = this.$el.querySelector(`#schedule_option_list_order${newListIndex}${index}`)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      })
    },
    delete_schedule_option_list: function (index, listIndex) {
      let optionArray = this.formData.scheduleGroupOptionStatus === '0' ? this.formData.scheduleOptionArray : this.formData.scheduleGroupOptionArray[this.statusData.selectedTab].schedule_option
      const option = optionArray[index]
      if (option) {
        const list = option.schedule_option_list[listIndex]
        if (list) {
          list.schedule_option_list_delete_status = 1
        } else {
          alert('삭제할 리스트 항목을 찾을 수 없습니다.')
        }
      } else {
        alert('해당하는 옵션을 찾을 수 없습니다.')
      }
      this.$forceUpdate()
    },
    add_schedule_group_option: function () {
      let lastOrder = 0
      if (this.formData.scheduleGroupOptionArray.length > 0) {
        lastOrder = Math.max(...this.formData.scheduleGroupOptionArray.map(option => option.schedule_group_option_order))
      }
      const newOption = {
        schedule_group_option_ID: 0,
        schedule_ID_use_schedule_group_option: 0,
        schedule_group_option_name: `리스트명${this.statusData.scheduleGroupOptionIndex + 1}`,
        schedule_group_option_name_error: '',
        schedule_group_option_order: lastOrder + 1,
        schedule_group_option_order_error: '',
        schedule_group_option_delete_status: 0,
        schedule_option: []
      }
      this.formData.scheduleGroupOptionArray.push(newOption)
      this.statusData.scheduleGroupOptionIndex++
    },
    selectTab: function (index) {
      this.statusData.selectedTab = index
    },
    copyGroupOption: function (index) {
      let lastOrder = 0
      if (this.formData.scheduleGroupOptionArray.length > 0) {
        lastOrder = Math.max(...this.formData.scheduleGroupOptionArray.map(option => option.schedule_group_option_order))
      }
      const groupToCopy = this.formData.scheduleGroupOptionArray[index]
      const newGroup = JSON.parse(JSON.stringify(groupToCopy))
      newGroup.schedule_group_option_ID = 0
      newGroup.schedule_group_option_order = lastOrder + 1
      newGroup.schedule_option.forEach(option => {
        option.schedule_option_ID = 0
        option.schedule_option_list.forEach(list => {
          list.schedule_option_list_ID = 0
        })
      })
      this.formData.scheduleGroupOptionArray.push(newGroup)
      this.statusData.selectedTab = this.formData.scheduleGroupOptionArray.length - 1
    },
    markAsDeleted: function (index) {
      this.formData.scheduleGroupOptionArray[index].schedule_group_option_delete_status = 1
      this.statusData.selectedTab = null
      this.$forceUpdate()
    },
    updateOrder: function () {
      this.formData.scheduleGroupOptionArray.forEach((option, index) => {
        option.schedule_group_option_order = index + 1
      })
    },
    getRowColor (index) {
      const colors = ['color1', 'color2']
      return colors[index % 2]
    },
    number_change: function (index, column_name, listIndex = 0) {
      let optionArray = this.formData.scheduleGroupOptionStatus === '0' ? this.formData.scheduleOptionArray : this.formData.scheduleGroupOptionArray[this.statusData.selectedTab].schedule_option
      if (column_name === 'schedule_option_order') {
        optionArray[index].schedule_option_order = removeWhitespace(optionArray[index].schedule_option_order.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else if (column_name === 'schedule_option_list_price') {
        optionArray[index].schedule_option_list[listIndex].schedule_option_list_price = removeWhitespace(optionArray[index].schedule_option_list[listIndex].schedule_option_list_price.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.$forceUpdate()
      } else if (column_name === 'schedule_option_list_price_child') {
        optionArray[index].schedule_option_list[listIndex].schedule_option_list_price_child = removeWhitespace(optionArray[index].schedule_option_list[listIndex].schedule_option_list_price_child.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.$forceUpdate()
      } else if (column_name === 'schedule_option_list_seats') {
        optionArray[index].schedule_option_list[listIndex].schedule_option_list_seats = removeWhitespace(optionArray[index].schedule_option_list[listIndex].schedule_option_list_seats.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.$forceUpdate()
      } else if (column_name === 'schedule_option_list_seats_max') {
        optionArray[index].schedule_option_list[listIndex].schedule_option_list_seats_max = removeWhitespace(optionArray[index].schedule_option_list[listIndex].schedule_option_list_seats_max.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.$forceUpdate()
      } else if (column_name === 'schedule_option_list_order') {
        optionArray[index].schedule_option_list[listIndex].schedule_option_list_order = removeWhitespace(optionArray[index].schedule_option_list[listIndex].schedule_option_list_order.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.$forceUpdate()
      }
    },
    number_change_general (field) {
      if (this.formData[field] !== '') {
        this.formData[field] = removeWhitespace(this.formData[field].replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },

    check_form: function () {
      this.errorData.scheduleStartDayError = this.formData.scheduleStartDay ? '' : '출발일을 입력해 주세요.'
      this.errorData.scheduleEndDayError = this.formData.scheduleEndDay ? '' : '종료일을 입력해 주세요.'
      this.errorData.schedulePriceError = this.formData.schedulePrice === '' && this.formData.scheduleOptionUseStatus === '2' ? '가격(대인)을 입력해 주세요.' : ''
      this.errorData.scheduleSeatsError = this.formData.scheduleSeats === '' && this.formData.scheduleOptionUseStatus === '2' ? '총 좌석수를 입력해 주세요.' : ''
      let isValid = true

      if (this.statusData.boardings.length === 0) {
        this.errorData.scheduleBoardingError = '탑승지는 최소 1개이상 입력하셔야 합니다.'
        isValid = false
      } else {
        this.errorData.scheduleBoardingError = ''
      }

      const checkOptions = (optionArray) => {
        let local_continue_add = true
        for (const element of optionArray) {
          if (element.schedule_option_delete_status === 0) {
            if (element.schedule_option_name === '') {
              element.schedule_option_name_error = '옵션명을 입력해 주세요.'
              local_continue_add = false
            } else {
              element.schedule_option_name_error = ''
            }
            if (element.schedule_option_order === '') {
              element.schedule_option_order_error = '순서를 입력해 주세요.'
              local_continue_add = false
            } else {
              element.schedule_option_order_error = ''
            }
            for (const element_option_list of element.schedule_option_list) {
              if (element_option_list.schedule_option_list_delete_status === 0) {
                if (element_option_list.schedule_option_list_name === '') {
                  element_option_list.schedule_option_list_name_error = '리스트명을 입력해 주세요.'
                  local_continue_add = false
                } else {
                  element_option_list.schedule_option_list_name_error = ''
                }
                if (element_option_list.schedule_option_list_order === '') {
                  element_option_list.schedule_option_list_order_error = '순서를 입력해 주세요.'
                  local_continue_add = false
                } else {
                  element_option_list.schedule_option_list_order_error = ''
                }
                if (element_option_list.schedule_option_list_price === '') {
                  element_option_list.schedule_option_list_price_error = '추가 금액을 입력해 주세요.'
                  local_continue_add = false
                } else {
                  element_option_list.schedule_option_list_price_error = ''
                }
                if (element_option_list.schedule_option_list_seats_max < 1) {
                  element_option_list.schedule_option_list_seats_max_error = '최소예약인원 좌석수는 1이상 입력하셔야 합니다.'
                  local_continue_add = false
                } else {
                  element_option_list.schedule_option_list_seats_max_error = ''
                }
              }
            }
          }
        }
        return local_continue_add
      }

      if (this.formData.scheduleGroupOptionStatus === '0') {
        isValid = checkOptions(this.formData.scheduleOptionArray) && isValid
      } else if (this.formData.scheduleGroupOptionStatus === '1') {
        for (let i = 0; i < this.formData.scheduleGroupOptionArray.length; i++) {
          if (this.formData.scheduleGroupOptionArray[i].schedule_group_option_delete_status === 0) {
            let local_continue_add = checkOptions(this.formData.scheduleGroupOptionArray[i].schedule_option)
            if (!local_continue_add) {
              this.statusData.selectedTab = i
              alert(`그룹 옵션 "${this.formData.scheduleGroupOptionArray[i].schedule_group_option_name}"에서 문제를 발견했습니다. 해당 탭으로 이동합니다.`)
              this.$forceUpdate()
              return
            }
          }
        }
      }
      this.formData.scheduleBoarding = JSON.stringify(this.statusData.boardings)
      if (
        isValid &&
        !this.errorData.scheduleStartDayError &&
        !this.errorData.scheduleEndDayError &&
        !this.errorData.schedulePriceError &&
        !this.errorData.scheduleSeatsError
      ) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.schedule_ID === undefined) {
          insert_schedule(
            this.formData.travelProductID,
            this.formData.scheduleStartDay,
            this.formData.scheduleEndDay,
            this.formData.scheduleBoarding,
            this.formData.schedulePrice,
            this.formData.schedulePriceChild,
            this.formData.scheduleSeats,
            this.formData.scheduleStatus,
            this.formData.scheduleOptionUseStatus,
            this.formData.scheduleGroupOptionStatus,
            this.formData.scheduleGroupOptionTitle,
            JSON.stringify(this.formData.scheduleGroupOptionArray),
            JSON.stringify(this.formData.scheduleOptionArray)
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminScheduleManagement'
          })
        } else {
          update_schedule(
            this.$route.query.schedule_ID,
            this.formData.travelProductID,
            this.formData.scheduleStartDay,
            this.formData.scheduleEndDay,
            this.formData.scheduleBoarding,
            this.formData.schedulePrice,
            this.formData.schedulePriceChild,
            this.formData.scheduleSeats,
            this.formData.scheduleStatus,
            this.formData.scheduleOptionUseStatus,
            this.formData.scheduleGroupOptionStatus,
            this.formData.scheduleGroupOptionTitle,
            JSON.stringify(this.formData.scheduleGroupOptionArray),
            JSON.stringify(this.formData.scheduleOptionArray)
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminScheduleManagement'
          })
        }
      } else {
        alert('입력값을 확인해주세요.')
      }
    }
  },
  computed: {
    optionSettingTitle () {
      if (this.formData.scheduleGroupOptionStatus === '0') {
        return '개별 옵션 설정'
      } else if (this.statusData.selectedTab !== null) {
        const selectedGroupName = this.formData.scheduleGroupOptionArray[this.statusData.selectedTab].schedule_group_option_name || '리스트'
        return `${selectedGroupName} 옵션 설정`
      }
    },
    optionButtonText () {
      if (this.formData.scheduleGroupOptionStatus === '0') {
        return '아래 "옵션 추가" 버튼을 클릭하여 개별 옵션과 리스트를 설정할 수 있습니다.'
      } else if (this.statusData.selectedTab !== null) {
        const selectedGroupName = this.formData.scheduleGroupOptionArray[this.statusData.selectedTab].schedule_group_option_name || '리스트'
        return `아래 "옵션 추가" 버튼을 클릭하여 ${selectedGroupName}의 세부 옵션을 설정할 수 있습니다.`
      }
      return '아래 "옵션 추가" 버튼을 클릭하여 그룹 옵션을 설정할 수 있습니다.'
    },
    filteredScheduleOptionArray: function () {
      if (this.formData.scheduleGroupOptionStatus === '0') {
        return this.formData.scheduleOptionArray
      } else if (this.formData.scheduleGroupOptionStatus === '1' && this.statusData.selectedTab !== null) {
        return this.formData.scheduleGroupOptionArray[this.statusData.selectedTab].schedule_option
      }
      return []
    }
  },
  mounted () {
    if (this.$route.query.schedule_ID !== undefined) {
      get_schedule_one(this.$route.query.schedule_ID).then((result) => {
        const schedule = result.schedule_rows[0]
        this.statusData.travelTypeDivision = schedule.travel_type_division
        this.formData.travelProductID = schedule.travel_product_ID_use_schedule
        this.formData.scheduleStartDay = schedule.schedule_start_day
        this.formData.scheduleEndDay = schedule.schedule_end_day
        this.statusData.boardings = JSON.parse(schedule.schedule_boarding)
        this.formData.schedulePrice = String(schedule.schedule_price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.formData.schedulePriceChild = String(schedule.schedule_price_child).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.formData.scheduleSeats = String(schedule.schedule_seats).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.formData.scheduleOptionUseStatus = String(schedule.schedule_option_use_status)
        this.formData.scheduleGroupOptionStatus = String(schedule.schedule_group_option_status)
        this.formData.scheduleGroupOptionTitle = schedule.schedule_group_option_title
        this.formData.scheduleStatus = String(schedule.schedule_status)

        if (String(schedule.schedule_group_option_status) === '0') {
          this.formData.scheduleOptionArray = result.schedule_option_rows.filter(
            option => option.schedule_group_option_ID_use_schedule_option === 0
          ); this.statusData.scheduleOptionIndex = this.formData.scheduleOptionArray.length
          this.statusData.scheduleOptionIndex = this.formData.scheduleOptionArray.length

          result.schedule_option_list_rows.forEach(option_list => {
            const option = this.formData.scheduleOptionArray.find(opt => opt.schedule_option_ID === option_list.schedule_option_ID_use_schedule_option_list)
            if (option) {
              if (!option.schedule_option_list) {
                option.schedule_option_list = []
              }
              option.schedule_option_list.push(option_list)
            }
          })
        } else {
          this.formData.scheduleGroupOptionArray = result.schedule_group_option_rows
          this.statusData.scheduleGroupOptionIndex = this.formData.scheduleGroupOptionArray.length

          this.formData.scheduleGroupOptionArray.forEach(groupOption => {
            groupOption.schedule_option = result.schedule_option_rows.filter(opt => opt.schedule_group_option_ID_use_schedule_option === groupOption.schedule_group_option_ID)
            groupOption.schedule_option.forEach(option => {
              if (!option.schedule_option_list) {
                option.schedule_option_list = []
              }
              option.schedule_option_list = result.schedule_option_list_rows.filter(optList => optList.schedule_option_ID_use_schedule_option_list === option.schedule_option_ID)
            })
          })
        }
      })
    } else {
      this.fetchTravelTypeUse(this.statusData.travelTypeDivision)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TravelManagement/AdminScheduleManagementAdd.vue